import {Injectable} from '@angular/core';
import {Capacitor, SystemBars, SystemBarsStyle} from '@capacitor/core';
import {SplashScreen} from '@capacitor/splash-screen';

@Injectable({providedIn: 'root'})
export class PlatformService {
	isMobileApp(): boolean {
		return Capacitor.isNativePlatform();
	}

	isIpad(): boolean {
		if (typeof navigator === 'undefined') {
			return false;
		}
		const ua = navigator.userAgent;
		return /\biPad\b/.test(ua) || (/\bMacintosh\b/.test(ua) && navigator.maxTouchPoints > 1);
	}

	getPlatform(): string {
		return Capacitor.getPlatform();
	}

	async initNativeShell(): Promise<void> {
		if (!this.isMobileApp()) {
			return;
		}

		document.body.classList.add('capacitor-native');

		try {
			await SystemBars.setStyle({style: SystemBarsStyle.Dark});
		} catch {
			// System bars API unavailable on some platforms.
		}

		try {
			await SplashScreen.hide();
		} catch {
			// Splash screen already hidden.
		}
	}
}
